import {
    GET_TRANSACTIONFEE_INFO_LOADING, TRANSACTIONFEE_DATA_SUCCESS,
    TRANSACTIONFEE_DATA_ERROR, TRANSACTIONFEE_DATA_RESET,GET_ALTERNATEMERCHANT_TRANSACTIONFEE_INFO_LOADING,
    ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_SUCCESS,ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_RESET,ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_ERROR
} from "../actions/actionTransactionFee";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "transactionFee";
const sessionKey2 = "alternateTransactionFee";

const initialState = {
    transactionFee: loadState(sessionKey1, []),
    alternateTransactionFee: loadState(sessionKey2, []),
    loading: false,
    transactionFeeError: '',
    alternateTransactionFeeError: ''
};

function reducerTransactionFee(state = initialState, action) {

    switch (action.type) {
        case GET_TRANSACTIONFEE_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }


        case TRANSACTIONFEE_DATA_SUCCESS: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                transactionFee: action.payload,
                transactionFeeError: ''
            };
        }

        case TRANSACTIONFEE_DATA_RESET: {

            saveState(sessionKey1, [])

            return {
                ...state,
                transactionFee: [],
                transactionFeeError: ''
            };
        }

        case TRANSACTIONFEE_DATA_ERROR: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                loading: false,
                transactionFeeError: action.error
            }
        }

        case GET_ALTERNATEMERCHANT_TRANSACTIONFEE_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_SUCCESS: {

            saveState(sessionKey2, action.payload)

            return {
                ...state,
                alternateTransactionFee: action.payload,
                alternateTransactionFeeError: ''
            };
        }

        case ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_RESET: {

            saveState(sessionKey2, [])

            return {
                ...state,
                alternateTransactionFee: [],
                alternateTransactionFeeError: ''
            };
        }

        case ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_ERROR: {

            saveState(sessionKey2, action.payload)

            return {
                ...state,
                loading: false,
                alternateTransactionFee: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerTransactionFee;